import React from 'react';
import PaymentRefresh from './Payment/PaymentRefresh';
import PaymentRecipt from './Payment/PaymentRecipt';

function PaymentServices() {
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                <div className='service-container'>
                    <PaymentRefresh />
                </div>
                <div className='service-container'>
                    <PaymentRecipt />
                </div>
            </div>
            <div>
                {/* <div className='service-container'>
                    <HandleSchedule />
                </div> */}
            </div>
        </div>
    )
};

export default PaymentServices;